import React from 'react';
import styles from './Skeleton.module.scss';

const Skeleton = ({ children }) => {
  return (
    <div className={styles.root}>
      <div className={styles.skeleton} />
      <div className={styles.btns}>{children}</div>
    </div>
  );
};

export default Skeleton;
